import React from 'react'
import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineBedSofaIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M20.4 7.0001c-.2 0-.5 0-.7.1v-.8c0-1.5-1.2-2.7-2.7-2.7h-3.2c-.6 0-1.2.2-1.7.6-.5-.4-1.1-.6-1.7-.6H7.1c-1.5 0-2.7 1.2-2.7 2.7v.8c-.3-.1-.5-.1-.7-.1-1.5 0-2.7 1.2-2.7 2.7v5.7c0 1.1.7 2.1 1.7 2.5v.9c0 .6.5 1 1 1 .6 0 1-.5 1-1v-.7h14.7v.7c0 .6.5 1 1 1 .6 0 1-.5 1-1v-.9c1-.4 1.7-1.4 1.7-2.5v-5.7c0-1.5-1.2-2.7-2.7-2.7Zm-13.3-1.4h3.2c.4 0 .7.3.7.7v4.1H6.4v-4.1c0-.4.3-.7.7-.7Zm6.6 0h3.2c.4 0 .7.3.7.7v4.1H13v-4.1c0-.4.3-.7.7-.7ZM3 9.7001c0-.4.3-.7.7-.7.4 0 .7.3.7.7v1.7c0 .6.5 1 1 1h13.3c.6 0 1-.5 1-1v-1.7c0-.4.3-.7.7-.7.4 0 .7.3.7.7v5.7c0 .4-.3.7-.7.7H3.7c-.4 0-.7-.3-.7-.7v-5.7Z"/>
  </SvgIcon>
}

export default LineBedSofaIcon
